/**
 * @generated SignedSource<<73902a2b6957cb374a33b9d0f0694604>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventQuery$variables = {
  id: string;
};
export type eventQuery$data = {
  readonly event: {
    readonly " $fragmentSpreads": FragmentRefs<"eventFragment">;
  };
};
export type eventQuery = {
  variables: eventQuery$variables;
  response: eventQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v22 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionResponse",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "eventFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "beginsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recurring",
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icalendar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recurrenceID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "originalStartTime",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "password",
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventGuest",
            "kind": "LinkedField",
            "name": "eventGuests",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assessmentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Contact",
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unmindUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SessionLimitPayload",
                    "kind": "LinkedField",
                    "name": "sessionLimits",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sessionLimitType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountRemaining",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiryDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrder",
                "kind": "LinkedField",
                "name": "salesOrders",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v5/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerLastName",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grandAmount",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventRecurringId",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Payment",
                    "kind": "LinkedField",
                    "name": "payment",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paidAt",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v16/*: any*/),
                      (v5/*: any*/),
                      (v11/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrderItem",
                    "kind": "LinkedField",
                    "name": "salesOrderItems",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quantity",
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discount",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v21/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "discountAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentTerms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIn",
                    "kind": "LinkedField",
                    "name": "paymentIns",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v11/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "payerEmail",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SalesOrder",
                        "kind": "LinkedField",
                        "name": "salesOrder",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventGuestAssessmentResponses",
                "kind": "LinkedField",
                "name": "eventGuestAssessmentResponses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventGuestAssessmentResponse",
                    "kind": "LinkedField",
                    "name": "GAD",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventGuestAssessmentResponse",
                    "kind": "LinkedField",
                    "name": "PHQ",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventGuestAssessmentResponse",
                    "kind": "LinkedField",
                    "name": "Workplace",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submittedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v15/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoUrls",
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupComplete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCredentials",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ethnicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "platformAccess",
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "createdByUserProfile",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zoomMeetingDetails",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleMeetDetails",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40472849a9fbeec85617dcf6734786ec",
    "id": null,
    "metadata": {},
    "name": "eventQuery",
    "operationKind": "query",
    "text": "query eventQuery(\n  $id: ID!\n) {\n  event(id: $id) {\n    ...eventFragment\n    id\n  }\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment contactBaseInlineFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  userId\n  unmindUserId\n  ...contactSessionLimitsRemainingInlineFragment\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment eventFragment on Event {\n  id\n  name\n  userId\n  accountId\n  description\n  location\n  beginsAt\n  endsAt\n  recurring\n  timeZone\n  type\n  source\n  createdBy\n  comment\n  status\n  icalendar\n  recurrenceID\n  originalStartTime\n  createdAt\n  session {\n    ...sessionFragment\n    ...sessionInlineFragment\n    id\n  }\n  eventGuests {\n    ...eventGuestInlineFragment\n    ...eventGuestFragment\n    id\n  }\n  userProfile {\n    ...userProfileBaseInlineFragment\n    ...userProfileNameInlineFragment\n    ...userProfileBaseFragment\n    ...userProfileNameFragment\n    account {\n      ...accountBaseFragment\n      id\n    }\n    id\n  }\n  createdByUserProfile {\n    ...userProfileNameInlineFragment\n    id\n  }\n  zoomMeetingDetails\n  sessionType\n  googleMeetDetails\n}\n\nfragment eventGuestAssessmentResponsesFragment on EventGuestAssessmentResponses {\n  GAD {\n    id\n    questionId\n    questionResponse\n  }\n  PHQ {\n    id\n    questionId\n    questionResponse\n  }\n  Workplace {\n    id\n    questionId\n    questionResponse\n  }\n  submittedAt\n}\n\nfragment eventGuestAssessmentResponsesInlineFragment on EventGuestAssessmentResponses {\n  GAD {\n    id\n    questionId\n    questionResponse\n  }\n  PHQ {\n    id\n    questionId\n    questionResponse\n  }\n  Workplace {\n    id\n    questionId\n    questionResponse\n  }\n  submittedAt\n}\n\nfragment eventGuestFragment on EventGuest {\n  id\n  status\n  assessmentStatus\n  contact {\n    id\n    accountId\n    firstName\n    lastName\n    email\n    source\n  }\n  salesOrders {\n    ...salesOrderFragment\n    id\n  }\n  eventGuestAssessmentResponses {\n    ...eventGuestAssessmentResponsesFragment\n  }\n}\n\nfragment eventGuestInlineFragment on EventGuest {\n  id\n  status\n  assessmentStatus\n  contact {\n    ...contactBaseInlineFragment\n    id\n  }\n  salesOrders {\n    ...salesOrderBaseInlineFragment\n    salesOrderItems {\n      ...salesOrderItemInlineFragment\n      id\n    }\n    id\n  }\n  eventGuestAssessmentResponses {\n    ...eventGuestAssessmentResponsesInlineFragment\n  }\n}\n\nfragment paymentBaseInlineFragment on Payment {\n  id\n  paidAt\n  amount\n  currencyCode\n  accountId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment productFragment on Product {\n  id\n  externalRef\n  accountId\n  name\n  description\n  type\n  price\n  currencyCode\n  meta\n  createdAt\n}\n\nfragment salesOrderAmountFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderBaseFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderBaseInlineFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  totalAmount\n  grandAmount\n  currencyCode\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n  payment {\n    ...paymentBaseInlineFragment\n    id\n  }\n}\n\nfragment salesOrderFragment on SalesOrder {\n  ...salesOrderBaseFragment\n  ...salesOrderAmountFragment\n  ...salesOrderPaymentsFragment\n  salesOrderItems {\n    ...salesOrderItemFragment\n    id\n  }\n}\n\nfragment salesOrderItemFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment salesOrderItemInlineFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment salesOrderPaymentsFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n\nfragment sessionFragment on Session {\n  id\n  password\n  externalRef\n}\n\nfragment sessionInlineFragment on Session {\n  id\n  password\n  externalRef\n}\n\nfragment userProfileBaseFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n  phone\n  languages\n  setupComplete\n  googleCredentials\n  gender\n  ethnicity\n}\n\nfragment userProfileBaseInlineFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n}\n\nfragment userProfileNameFragment on UserProfile {\n  firstName\n  lastName\n}\n\nfragment userProfileNameInlineFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "064cad1b5539629add89b7aaf4b254be";

export default node;
